import { defineMessages } from 'react-intl'

export const auditTableMessages = defineMessages({
  date: {
    id: 'auditTableMessages.date',
    description: 'Text for Audit table header of "Date"',
    defaultMessage: 'Date',
  },
  domain: {
    id: 'auditTableMessages.domain',
    description: 'Text for Audit table header of "Domain"',
    defaultMessage: 'Domain',
  },
  user: {
    id: 'auditTableMessages.user',
    description: 'Text for Audit table header of "User"',
    defaultMessage: 'User',
  },
  action: {
    id: 'auditTableMessages.action',
    description: 'Text for Audit table header of "Action"',
    defaultMessage: 'Action',
  },
})
